import { styled, XStack } from "tamagui";
import { pillSizes } from "../themes/token-pill";
import { Body3 } from "./Typography";
const SIZE = "$si5";
export const SelectionPillFrame = styled(XStack, {
  name: "SelectionPillFrame",
  height: SIZE,
  paddingHorizontal: pillSizes[SIZE].sidePadding,
  gap: pillSizes[SIZE].gap,
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$brFull",
  // Not the "transparent" keyword: native can't animate a fill from it.
  backgroundColor: "rgba(0, 0, 0, 0)",
  variants: {
    fill: {
      none: {},
      brand: {
        backgroundColor: "$bgBrand"
      },
      neutral: {
        backgroundColor: "$surface0",
        hoverStyle: {
          backgroundColor: "$surface0Hover"
        },
        pressStyle: {
          backgroundColor: "$surface0Hover"
        }
      }
    }
  } as const,
  defaultVariants: {
    fill: "none"
  }
});
export const SelectionPillLabel = styled(Body3, {
  name: "SelectionPillLabel",
  variants: {
    look: {
      off: {
        color: "$textSubtle"
      },
      brandOn: {
        size: "$subtitle3",
        color: "$textBrandStrong"
      },
      neutralOn: {
        size: "$subtitle3",
        color: "$textDefault"
      }
    },
    disabled: {
      true: {
        color: "$textMuted"
      }
    }
  } as const,
  defaultVariants: {
    look: "off"
  }
});